import request from '@/utils/request'

// 获取客服列表
export function getCustomerUserList() {
  return request({
    url: '/customer/user/getCustomerUserList',
    method: 'get'
  })
}
// 工作动态列表
export function getWorkDynamic(params) {
  return request({
    url: '/cms/workDynamic/findPage',
    method: 'get',
    params
  })
}

// 工作动态详情
export function getWorkDetail(id) {
  return request({
    url: '/cms/workDynamic/findOne/' + id,
    method: 'get'
  })
}

// 轮播图
export function getCarousels(params) {
  return request({
    url: '/cms/carousel/findPage',
    method: 'get',
    params
  })
}

// 轮播图
export function getStatNum() {
  return request({
    url: '/statistics/num',
    method: 'get'
  })
}

// 平台优惠列表
export function getDiscounts(params) {
  return request({
    url: '/cms/platformDiscount/findPage',
    method: 'get',
    params
  })
}

// 平台优惠详情
export function getDiscountsDetail(id) {
  return request({
    url: '/cms/platformDiscount/findOne/' + id,
    method: 'get'
  })
}

// 知识课堂表
export function getClassroom(params) {
  return request({
    url: '/cms/knowledge/findPage',
    method: 'get',
    params
  })
}

// 政务服务列表
export function getGovernment(params) {
  return request({
    url: '/cms/gov/channel/findData',
    method: 'get',
    params
  })
}

// 优选机构列表
export function getOrgOptimize() {
  return request({
    url: '/serv/org/info/orgOptimize',
    method: 'get'
  })
}
// 热门服务列表
export function getHotService() {
  return request({
    url: '/serv/content/hotServ',
    method: 'get'
  })
}

// 首页-（培训咨询、区域品牌、政策法规）
export function getRegionBrandPolicy() {
  return request({
    url: '/cms/home/findRegionBrandData',
    method: 'get'
  })
}

// 政策法规数据查询（政策法规、惠企政策）
export function getPolicy() {
  return request({
    url: '/cms/home/findRtfData',
    method: 'get'
  })
}

// 培训咨询数据查询（培训动态、专家观点）
export function getTrain(data) {
  return request({
    url: '/cms/home/findTrainData',
    method: 'get',
    params: data
  })
}

// 标准动态
export function getStandardList(data) {
  return request({
    url: '/system/standard/getStandard',
    method: 'get',
    params: data
  })
}

// 产品召回列表
export function getRecallList(data) {
  return request({
    url: '/cms/productRecall/findPage',
    method: 'get',
    params: data
  })
}

// 产品召回详情
export function getRecallDetail(id) {
  return request({
    url: '/cms/productRecall/findOne/' + id,
    method: 'get',
  })
}